import { isSafeUrl } from "@memorang/helpers/common";
import { Image, type ImageSourcePropType, Pressable } from "react-native";
import { useTheme } from "react-native-paper";
import Box from "../Box";

type OnPressBadge = (params: { href: string; platform: string }) => void;

const AppStoreDownloadBadge = ({
	src,
	href,
	platform,
	onPressBadge,
}: {
	src: ImageSourcePropType;
	href: string;
	platform: string;
	onPressBadge?: OnPressBadge;
}) => {
	const handlePress = () => {
		onPressBadge?.({ href, platform });
		if (!isSafeUrl(href, { allowedSchemes: ["https"] })) {
			return;
		}
		// biome-ignore lint/suspicious/noExplicitAny: web-only API
		(window as any).open(href, "_blank", "noopener,noreferrer");
	};

	return (
		<Pressable onPress={handlePress}>
			<Image
				source={src}
				style={{
					width: 121,
					height: 36,
					resizeMode: "contain",
				}}
			/>
		</Pressable>
	);
};

type Badge = {
	light: ImageSourcePropType;
	dark: ImageSourcePropType;
};

type Props = {
	ios: {
		badge: Badge;
		href?: string;
	};
	android: {
		badge: Badge;
		href?: string;
	};
	onPressBadge?: OnPressBadge;
};

const StoresDownloadBadge = ({ ios, android, onPressBadge }: Props) => {
	const theme = useTheme();
	const platforms = [
		{
			platform: "ios",
			...ios,
		},
		{
			platform: "android",
			...android,
		},
	];

	const hasNoLinks = !(ios.href || android.href);

	if (hasNoLinks) {
		return null;
	}

	return (
		<Box flexDirection="row" alignItems="center" gap={4}>
			{platforms.map(({ platform, badge, href }) =>
				href ? (
					<AppStoreDownloadBadge
						key={platform}
						src={theme.dark ? badge.dark : badge.light}
						href={href}
						platform={platform}
						onPressBadge={onPressBadge}
					/>
				) : null,
			)}
		</Box>
	);
};

export default StoresDownloadBadge;
